export const HAS = 'has';
export const ACTIVE = 'active';
export const BUY = 'buy';
export const CHOOSE = 'choose';
